import React from 'react';
import { C, FILTER_TYPES, formatFilterLabel } from './shared';

/**
 * FilterBar — toggle button with active-count badge, dismissable chips, "Reset all".
 */
export default function FilterBar({
  filters,           // draft (shown in chips when panel is closed)
  appliedFilters,    // committed (shown as chips in the bar)
  showPanel,
  onTogglePanel,
  onRemove,
  onToggleOperator,
  onReset,
  hasPendingChanges,
  onApply,
}) {
  // Chips show applied filters (what's actually active in the search)
  const chips = appliedFilters || filters;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      {/* Toggle button */}
      <button
        onClick={onTogglePanel}
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '6px 14px', borderRadius: 7, cursor: 'pointer', fontSize: 13, fontWeight: 500,
          border: `1px solid ${chips.length > 0 ? C.primary : C.border}`,
          background: chips.length > 0 ? `${C.primary}12` : '#fff',
          color: chips.length > 0 ? C.primary : C.textMd,
        }}
      >
        <span>⚡ Filters</span>
        {chips.length > 0 && (
          <span style={{
            background: C.primary, color: '#fff',
            borderRadius: 10, padding: '1px 7px', fontSize: 11, fontWeight: 700,
          }}>
            {chips.length}
          </span>
        )}
      </button>

      {/* Pending changes indicator */}
      {hasPendingChanges && (
        <button
          onClick={onApply}
          style={{
            padding: '5px 14px', borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: 'pointer',
            border: 'none', background: C.primary, color: '#fff',
          }}
        >
          🔍 Apply
        </button>
      )}

      {/* Active filter chips with AND/OR badges between them */}
      {chips.map((f, i) => {
        const ft = FILTER_TYPES.find(t => t.value === f.field);
        return (
          <React.Fragment key={f.id}>
            {/* AND/OR badge between chips */}
            {i > 0 && (
              <button
                onClick={() => onToggleOperator(f.id)}
                title="Click to toggle AND/OR"
                style={{
                  padding: '2px 7px', borderRadius: 4, fontSize: 11, fontWeight: 700,
                  cursor: 'pointer', border: '1px solid',
                  borderColor: f.operator === 'or' ? '#f59e0b' : C.primary,
                  background: f.operator === 'or' ? '#fef3c720' : `${C.primary}10`,
                  color: f.operator === 'or' ? '#f59e0b' : C.primary,
                }}
              >
                {f.operator.toUpperCase()}
              </button>
            )}

            {/* Chip */}
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 4,
              background: '#f1f5f9', border: `1px solid ${C.border}`,
              borderRadius: 6, padding: '3px 6px 3px 8px', fontSize: 12,
            }}>
              <span style={{ color: C.textMd }}>{ft?.label}</span>
              <span style={{ color: C.text, fontWeight: 600, marginLeft: 2 }}>
                {formatFilterLabel(f)}
              </span>
              <button
                onClick={() => onRemove(f.id)}
                style={{
                  background: 'none', border: 'none', color: C.textSm,
                  cursor: 'pointer', fontSize: 15, padding: '0 2px', lineHeight: 1,
                }}
              >
                ×
              </button>
            </div>
          </React.Fragment>
        );
      })}

      {/* Reset all */}
      {chips.length > 0 && (
        <button
          onClick={onReset}
          style={{
            background: 'none', border: 'none', color: C.textSm,
            cursor: 'pointer', fontSize: 12, textDecoration: 'underline', padding: 0,
          }}
        >
          Reset all
        </button>
      )}
    </div>
  );
}
